<template>
  <div class="fixed-top menucontrol-scroll">
    <Banner />
    <AlbumTable />
  </div>
</template>
<script>
import Banner from "./components/Banner.vue";
// import AlbumTable from "./components/AlbumTable.vue";
import AlbumTable from "./components/NewAlbum.vue";
export default {
  components: {
    Banner,
    AlbumTable,
  },
};
</script>
